import axios from "axios";
import { useDispatch } from "react-redux";
import { EMenuActions } from "./store";
import { TaxActions } from "./store/tax";
import { toast } from "react-toastify";
import { CompanyActions } from "./store/company_dtl";
import { useParams } from "react-router-dom";

const useInitialize = () => {
  const dispatch = useDispatch();
  const { m_id, table_number, room_number } = useParams();
  const favouriteProduct = JSON.parse(localStorage.getItem("Favourites")) || [];
  const T_URL = extractSubdomainFromURL();

  const base_url = `https://${T_URL}.cranesoft-digitalmenu.com`;
  const lclItems = JSON.parse(localStorage.getItem("cartItems")) || [];

  // Extract subdomain from URL
  function extractSubdomainFromURL() {
    try {
      const parsedURL = new URL(window.location.href);
      const hostnameParts = parsedURL.hostname.split(".");
      return hostnameParts.length >= 2 ? hostnameParts[0] : null;
    } catch (error) {
      console.error("Error extracting subdomain:", error);
      return null;
    }
  }

  // Fetch and set the token
  const tokenDetails = async () => {
    try {
      const response = await axios.get(`${base_url}/tenantApiToken`);
      const token = response.data.tenantAPIToken;
      dispatch(CompanyActions.setAuthToken(`Bearer ${token}`));

      await Promise.all([
        companyDetails(token),
        SettingEnabled(token),
        products(token),
        SalesPoint(token),
        PayStack_PK(token),
        reviewQuestions(token),
        ShippingList(token),
        ViewOrder(token),
      ]);
    } catch (error) {
      console.warn(error);
    }
  };

  // Fetch company details
  const companyDetails = async (token) => {
    try {
      if (m_id) {
        // console.log("id", m_id);
        const response = await axios.get(
          `${base_url}/api/v1/salespointLandingPage/${m_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCompanyData(response.data, token, m_id);
      } else if (table_number) {
        const response = await axios.get(
          `${base_url}/api/v1/tableLandingPage/${table_number}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
            console.log("room", response.data);
        setTableData(response.data, token, table_number);
      } else if (room_number) {
        const response = await axios.get(
          `${base_url}/api/v1/roomLandingPage/${room_number}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setTableData(response.data, token, room_number);
        // console.log("Room data:", response.data);
      } else {
        const response = await axios.get(
          `${base_url}/api/v1/waiterLandingPage/${m_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCompanyData(response.data, token, m_id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Helper to set company data
  const setCompanyData = (data, token, m_id) => {
    dispatch(CompanyActions.setCompanyName(data.company.company_name));
    dispatch(CompanyActions.setC_URL(data.currentDomain[0].domain));
    dispatch(CompanyActions.setM_ID(m_id));
    dispatch(CompanyActions.setT_ID(data.company.tenantId));
    dispatch(EMenuActions.setCategories(data.groupList));
    dispatch(CompanyActions.setReviewLic(data.reviewLic));
    dispatch(CompanyActions.setPOSLic(data.POSLic));
    console.log("data: ", data);
    document.title = `${data.company.company_name} - Menu`;
    sessionStorage.setItem("domain", data.currentDomain[0].domain);
    sessionStorage.setItem("tenant_id", data.currentDomain[0].tenant_id);
    SalesPoint(token, data, m_id);
    Tables(token, m_id, table_number, data);
    dispatch(EMenuActions.setLoading(false));
    if (lclItems.length > 0) {
      dispatch(EMenuActions.setCartItems(lclItems));
      toast.info("You have items in the Cart", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  // Helper to set table data
  const setTableData = (data, token, table_number) => {
    dispatch(CompanyActions.setCompanyName(data.company.company_name));
    dispatch(CompanyActions.setC_URL(data.currentDomain[0].domain));
    dispatch(CompanyActions.setM_ID(data.tableInfo[0].SalesPoint));
    dispatch(CompanyActions.setTableMenuId(data.tableInfo[0].SalesPoint));
    dispatch(CompanyActions.setT_ID(data.company.tenantId));
    dispatch(CompanyActions.setTableID(table_number));
    dispatch(EMenuActions.setCategories(data.groupList));
    dispatch(CompanyActions.setReviewLic(data.reviewLic));
    dispatch(CompanyActions.setPOSLic(data.POSLic));
    document.title = `${data.company.company_name} - Menu`;
    sessionStorage.setItem("domain", data.currentDomain[0].domain);
    sessionStorage.setItem("tenant_id", data.currentDomain[0].tenant_id);
    SalesPoint(token, data.tableInfo[0].SalesPoint, m_id);
    Tables(token, m_id, data.tableInfo[0].TableNo, data.tableInfo[0].id);
    if (lclItems.length > 0) {
      dispatch(EMenuActions.setCartItems(lclItems));
      toast.info("You have items in the Cart", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  // Fetch and set company settings
  const SettingEnabled = async (token) => {
    try {
      const response = await axios.get(`${base_url}/api/v1/SettingInfo`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const settings = response.data.data;
      const bgImage = settings.find(
        (setting) => setting.name === "background_image"
      ).value;
      localStorage.setItem("bgimage", bgImage);
      localStorage.setItem("backgroundLoaded", true);
      dispatch(CompanyActions.setBgImage(true));
      dispatch(EMenuActions.setLoading(false));
      dispatch(CompanyActions.setCompanySettings(settings));
      dispatch(CompanyActions.setShippingsEnabled(settings[4].value));
      setTaxRate(settings);
    } catch (error) {
      console.error(error);
    }
  };

  // Set tax rate
  const setTaxRate = (settings) => {
    const chargeType = settings.find(
      (setting) => setting.name === "Charge_Type"
    );
    const vatRate = settings.find((setting) => setting.name === "VATRate");
    const stateRate = settings.find((setting) => setting.name === "StateRate");
    const hideTax = settings.find((setting) => setting.name === "Hide_Tax");
    const serviceRate = settings.find(
      (setting) => setting.name === "ServiceRate"
    );

    if (chargeType) {
      dispatch(TaxActions.setChargeType(chargeType.value));
      dispatch(TaxActions.setVatRate(Number(vatRate.value)));
      dispatch(TaxActions.setStateRate(Number(stateRate.value)));
      dispatch(TaxActions.setServiceRate(Number(serviceRate.value)));
      dispatch(
        TaxActions.setSumOfTax(
          (Number(vatRate.value) +
            Number(stateRate.value) +
            Number(serviceRate.value)) /
            100
        )
      );
      dispatch(TaxActions.setHideTax(hideTax.value));
    }
  };

  // Fetch products
  const products = async () => {
      // dispatch(EMenuActions.setAllProducts(response.data.products));
      dispatch(EMenuActions.setFavouriteProduct(favouriteProduct));
  };

  // Fetch sales point
  const SalesPoint = async (token, tableMenu, m_id) => {
    try {
      const response = await axios.get(`${base_url}/api/v1/Menu`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const salesPoint = response.data.find(
        (sp) => sp.MenuId === m_id || sp.MenuId === tableMenu
      );
      if (salesPoint) {
        dispatch(CompanyActions.setSalesPoint(salesPoint.id));
        dispatch(CompanyActions.setSalesPointName(salesPoint.Name));
        await BranchID(token, salesPoint.BranchId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch branch ID
  const BranchID = async (token, id) => {
    try {
      const response = await axios.get(`${base_url}/api/v1/Branch`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const branch = response.data.find((branch) => branch.id === Number(id));
      if (branch) {
        dispatch(CompanyActions.setBranchId(branch.Name));
        dispatch(CompanyActions.setStoreId(branch.id));
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch tables
  const Tables = async (token, id, table, tableId) => {
    try {
      if (m_id) {
        const response = await axios.get(`${base_url}/api/v1/OrderTable`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch(CompanyActions.setAV_TB(response.data));
      } else if (table_number) {
        dispatch(CompanyActions.setTableNo(table));
        dispatch(CompanyActions.setSL_TB_ID(tableId));
      } else if (room_number) {
        // console.log("Room number in tables");
      }
    } catch (error) {
      console.warn(error);
    }
  };

  // Fetch PayStack public key
  const PayStack_PK = async (token) => {
    try {
      const response = await axios.get(`${base_url}/api/v1/PaymentInfo`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(CompanyActions.setPaystackEnabled(response.data.data[0].name));
      dispatch(CompanyActions.setPaystack(response.data.data[2].value));
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch review questions
  const reviewQuestions = async (token) => {
    try {
      const response = await axios.get(
        `${base_url}/api/v1/CustomerReviews/Question`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      dispatch(EMenuActions.setReviewQuestions(response.data));
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch shipping list
  const ShippingList = async (token) => {
    try {
      const response = await axios.get(`${base_url}/api/v1/ShippingLocation`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(CompanyActions.setShippingsList(response.data));
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch waiter call option
  const ViewOrder = async (token) => {
    try {
      const response = await axios.get(
        `${base_url}/api/v1/getWaiterCallOption`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      dispatch(CompanyActions.setWaiterCall(response.data));
    } catch (error) {
      console.error(error);
    }
  };

  return { getTokenDetails: tokenDetails };
};

export default useInitialize;
